import { QueryHookOptions, useQuery } from "@apollo/client";
import { graphql } from "~/gql";
import { FindOfficeLocationsQuery, FindOfficeLocationsQueryVariables } from "~/gql/graphql";

export const OFFICE_LOCATIONS_QUERY = graphql(/* GraphQL */ `
  query FindOfficeLocations {
    officeLocations {
      id
      countryCode
      name
      externalReference
      taxLabel
      taxLevelPercent
    }
  }
`);

export function useOfficeLocationsQuery(
  options?: QueryHookOptions<FindOfficeLocationsQuery, FindOfficeLocationsQueryVariables>
) {
  return useQuery<FindOfficeLocationsQuery, FindOfficeLocationsQueryVariables>(
    OFFICE_LOCATIONS_QUERY,
    options
  );
}
